"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityConnectionsToolbar = exports.EntityConnectionsToolbarDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var icon_button_1 = require("../elements/icon-button");
var slider_1 = require("../elements/slider");
var use_full_screen_state_1 = require("../../hooks/use-full-screen-state");
var use_lang_1 = require("../../hooks/use-lang");
var use_icons_1 = require("../../hooks/use-icons");
exports.EntityConnectionsToolbarDefaultProps = {
  buttonSize: 24,
  depth: 1,
  maxDepth: 3,
  spacing: 3,
  showDepthControls: true,
  onDownloadClick: function () {},
  onBackClick: function () {
    if (typeof window !== undefined) window.history.back();
  },
  onForwardClick: function () {
    if (typeof window !== undefined) window.history.forward();
  },
  onAutoZoomClick: function () {},
  onSpacingChange: function (spacing) {},
  onDepthChange: function (depth) {}
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-self: center;\n    flex-shrink: 0;\n    flex-direction: row;\n    align-items: center; \n    justify-content: space-between;\n  "], ["\n    display: flex;\n    align-self: center;\n    flex-shrink: 0;\n    flex-direction: row;\n    align-items: center; \n    justify-content: space-between;\n  "])))
});
var ItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n\n    padding-right: ", ";\n  "], ["\n    display: flex;\n\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(1))
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: 0 0 0 ", ";\n    background-position: top right;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:first-child {\n      padding-left: 0;\n    }\n\n    ", "\n\n    ", "\n  "], ["\n    padding: 0 0 0 ", ";\n    background-position: top right;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:first-child {\n      padding-left: 0;\n    }\n\n    ", "\n\n    ", "\n  "])), theme_1.theme.UNIT(4), function (props) {
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), props.buttonSize + 16, props.buttonSize + 16);
  }, function (props) {
    return props.hideBorder && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      border: none;\n    "], ["\n      border: none;\n    "])));
  })
});
var SliderContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-left: 12px;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-left: 12px;\n  "])))
});
var SpacingSliderContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n  "], ["\n    ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n  "])), SliderContainerStyles, theme_1.theme.UNIT(5), theme_1.theme.UNIT(3))
});
var SliderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: 60px; \n  "], ["\n    width: 60px; \n  "])))
});
var SpacingSliderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    width: 60px; \n  "], ["\n    width: 60px; \n  "])))
});
var SliderLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    font-size: ", ";\n    text-transform: uppercase;\n    color: ", ";\n    margin-right: ", ";\n\n    ", "\n  "], ["\n    font-size: ", ";\n    text-transform: uppercase;\n    color: ", ";\n    margin-right: ", ";\n\n    ", "\n  "])), theme_1.theme.FONT_SIZE(12), theme_1.theme.COLOR('text-mid'), theme_1.theme.UNIT(2), function (props) {
    return props.disabled && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      opacity: 0.3;\n    "], ["\n      opacity: 0.3;\n    "])));
  })
});
var IconButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var DownloadLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    cursor: pointer;\n  "], ["\n    cursor: pointer;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SliderContainer: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), SliderContainerStyles),
  SpacingSliderContainer: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), SpacingSliderContainerStyles),
  SliderLabel: styled_components_1.default.span(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), SliderLabelStyles),
  Slider: (0, styled_components_1.default)(slider_1.Slider)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), SliderStyles),
  SpacingSlider: (0, styled_components_1.default)(slider_1.Slider)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), SpacingSliderStyles),
  DownloadLink: styled_components_1.default.a(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), DownloadLinkStyles),
  Items: styled_components_1.default.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled_components_1.default.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  IconButton: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), IconButtonStyles)
};
var EntityConnectionsToolbar = function (props) {
  var className = props.className,
    buttonSize = props.buttonSize,
    depth = props.depth,
    maxDepth = props.maxDepth,
    spacing = props.spacing,
    onDepthChange = props.onDepthChange,
    onForwardClick = props.onForwardClick,
    onBackClick = props.onBackClick,
    onAutoZoomClick = props.onAutoZoomClick,
    onSpacingChange = props.onSpacingChange,
    showDepthControls = props.showDepthControls;
  var _a = (0, use_full_screen_state_1.useFullScreenState)(),
    toggleFullScreen = _a.toggleFullScreen,
    isFullScreen = _a.isFullScreen;
  var Icons = (0, use_icons_1.useIcons)();
  var t = (0, use_lang_1.useLang)();
  var isSpacingDisabled = showDepthControls ? depth <= 1 : false;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Items, null, react_1.default.createElement(My.Item, {
    buttonSize: buttonSize,
    title: t('Back')
  }, react_1.default.createElement(My.IconButton, {
    color: "dark",
    hoverColor: "primary",
    iconSize: buttonSize,
    onClick: onBackClick,
    icon: react_1.default.createElement(Icons.Toolbar.ArrowLeft, null)
  })), react_1.default.createElement(My.Item, {
    buttonSize: buttonSize,
    title: t('Forward')
  }, react_1.default.createElement(My.IconButton, {
    color: "dark",
    hoverColor: "primary",
    iconSize: buttonSize,
    onClick: onForwardClick,
    icon: react_1.default.createElement(Icons.Toolbar.ArrowRight, null)
  })), showDepthControls && react_1.default.createElement(My.SliderContainer, {
    title: t('Control the depth of connections in the diagram. 1 will show immediate connections, 2 will also show connections of connections, and so on.')
  }, react_1.default.createElement(My.SliderLabel, null, t('Depth'), ":"), react_1.default.createElement(My.Slider, {
    showValue: true,
    value: depth,
    onChange: onDepthChange,
    min: 1,
    max: maxDepth
  })), isFullScreen ? react_1.default.createElement(My.Item, {
    buttonSize: buttonSize,
    title: t('Exit Full Screen')
  }, react_1.default.createElement(My.IconButton, {
    color: "dark",
    hoverColor: "primary",
    iconSize: buttonSize,
    onClick: toggleFullScreen,
    icon: react_1.default.createElement(Icons.Toolbar.LeaveFullScreen, null)
  })) : react_1.default.createElement(My.Item, {
    buttonSize: buttonSize,
    title: t('Enter Full Screen')
  }, react_1.default.createElement(My.IconButton, {
    color: "dark",
    hoverColor: "primary",
    iconSize: buttonSize,
    onClick: toggleFullScreen,
    icon: react_1.default.createElement(Icons.Toolbar.FullScreen, null)
  }))));
};
exports.EntityConnectionsToolbar = EntityConnectionsToolbar;
exports.EntityConnectionsToolbar.defaultProps = exports.EntityConnectionsToolbarDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23;